<template>
    <AppDialog
        closeable
        :show="subAccountData?.showState"
        @close="closeDialog"
        :title="handleActiveComponent?.title"
        :title-icon="handleActiveComponent?.titleIcon"
        :icon-class="handleActiveComponent?.iconClass"
    >
        <template #default>
            <Suspense>
                <component :is="handleActiveComponent?.component" @close="closeDialog" />

                <!-- * loading SVG (for higher speed it is not in a separate file) -->
                <template #fallback>
                    <div class="text-gray-100 xl:w-[520px] w-[350px] flex justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                            <path
                                fill="currentColor"
                                d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                opacity=".25"
                            />
                            <path
                                fill="currentColor"
                                d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                            >
                                <animateTransform
                                    attributeName="transform"
                                    dur="0.75s"
                                    repeatCount="indefinite"
                                    type="rotate"
                                    values="0 12 12;360 12 12"
                                />
                            </path>
                        </svg>
                    </div>
                </template>
            </Suspense>
        </template>
    </AppDialog>
</template>

<script setup lang="ts">
import { useSubAccountStore } from "../../store";

const { subAccountData } = storeToRefs(useSubAccountStore());

const emit = defineEmits(["closeModal"]);

const { t } = useI18n();

const handleActiveComponent = computed(() => {
    switch (subAccountData.value?.type) {
        case "locked":
            return {
                component: defineAsyncComponent(() => import("./SubAccountLocked.vue")),
                titleIcon: "tabler:lock",
                title: t("pages_subaccount_dialog_locked_title"),
                iconClass: "text-gray-400",
            };
        case "limited":
            return {
                component: defineAsyncComponent(() => import("./SubAccountLimited.vue")),
                titleIcon: "tabler:alert-triangle",
                title: t("pages_sub_account_limited_modal_title"),
                iconClass: "text-gray-400",
            };
        case "no-credits":
            return {
                component: defineAsyncComponent(() => import("./SubAccountNotEnoughCredit.vue")),
                title: t("pages_subaccount_dialog_noCredit_title"),
            };
        case "removed":
            return {
                component: defineAsyncComponent(() => import("./SubAccountRemoved.vue")),
                titleIcon: "tabler:lock",
                title: t("pages_sub_account_removed_modal_title"),
                iconClass: "text-gray-400",
            };
        case "vs-manual-limited":
            return {
                component: defineAsyncComponent(() => import("./SubAccountVsManualLimited.vue")),
                titleIcon: "tabler:alert-triangle",
                title: t("pages_sub_account_limited_modal_title"),
                iconClass: "text-gray-400",
            };

        default:
            break;
    }
});

function closeDialog() {
    emit("closeModal");
}
</script>
